export default __webpack_public_path__ + "static/media/tailwindcss.cb8046c1.svg";